const perceptType = [
  { key: '001', value: 'Sueldos, Salarios  Rayas y Jornales' },
  { key: '002', value: 'Gratificación Anual (Aguinaldo)' },
  { key: '003', value: 'Participación de los Trabajadores en las Utilidades PTU' },
  { key: '004', value: 'Reembolso de Gastos Médicos Dentales y Hospitalarios' },
  { key: '005', value: 'Fondo de Ahorro' },
  { key: '006', value: 'Caja de ahorro' },
  { key: '009', value: 'Contribuciones a Cargo del Trabajador Pagadas por el Patrón' },
  { key: '010', value: 'Premios por puntualidad' },
  { key: '011', value: 'Prima de Seguro de vida' },
  { key: '012', value: 'Seguro de Gastos Médicos Mayores' },
  { key: '013', value: 'Cuotas Sindicales Pagadas por el Patrón' },
  { key: '014', value: 'Subsidios por incapacidad' },
  { key: '015', value: 'Becas para trabajadores y/o hijos' },
  { key: '019', value: 'Horas extra' },
  { key: '020', value: 'Prima dominical' },
  { key: '021', value: 'Prima vacacional' },
  { key: '022', value: 'Prima por antigüedad' },
  { key: '023', value: 'Pagos por separación' },
  { key: '024', value: 'Seguro de retiro' },
  { key: '025', value: 'Indemnizaciones' },
  { key: '026', value: 'Reembolso por funeral' },
  { key: '027', value: 'Cuotas de seguridad social pagadas por el patrón' },
  { key: '028', value: 'Comisiones' },
  { key: '029', value: 'Vales de despensa' },
  { key: '030', value: 'Vales de restaurante' },
  { key: '031', value: 'Vales de gasolina' },
  { key: '032', value: 'Vales de ropa' },
  { key: '033', value: 'Ayuda para renta' },
  { key: '034', value: 'Ayuda para artículos escolares' },
  { key: '035', value: 'Ayuda para anteojos' },
  { key: '036', value: 'Ayuda para transporte' },
  { key: '037', value: 'Ayuda para gastos de funeral' },
  { key: '038', value: 'Otros ingresos por salarios' },
  { key: '039', value: 'Jubilaciones, pensiones o haberes de retiro' },
  { key: '044', value: 'Jubilaciones, pensiones o haberes de retiro en parcialidades' },
  { key: '045', value: 'Ingresos en acciones o títulos valor que representan bienes' },
  { key: '046', value: 'Ingresos asimilados a salarios' },
  { key: '047', value: 'Alimentación' },
  { key: '048', value: 'Habitación' },
  { key: '049', value: 'Premios por asistencia' },
  { key: '050', value: 'Viáticos' },
  { key: '051', value: 'Pagos por gratificaciones, primas, compensaciones, recompensas u otros a extrabajadores derivados de jubilación en parcialidades' },
  { key: '052', value: 'Pagos que se realicen a extrabajadores que obtengan una jubilación en parcialidades derivados de la ejecución de resoluciones judicial o de un laudo' },
  { key: '053', value: 'Pagos que se realicen a extrabajadores que obtengan una jubilación en una sola exhibición derivados de la ejecución de resoluciones judicial o de un laudo' },
];

module.exports = perceptType;
